import axios from '@/axios';

// URL and endpoint constants
const INDEX_URL = '/news';

export default {
  index(page, succ) {
    axios.get(INDEX_URL, { params: { page } })
      .then((response) => { succ(response); });
  },
};



// WEBPACK FOOTER //
// ./src/api/v1/news.js